module.exports = __webpack_public_path__ + "static/media/img-scope3.cf863ea0.png";